import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setRouteStrings } from '@/actions/routes/routesPure';
import WeightWatcher from '@/components/Common/Weights';
import {
  Box,
  Typography,
  IconButton,
  Divider,
  Card,
  CardContent,
  ListItemText,
  Tooltip,
  Collapse,
  Button,
  Chip,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from '@mui/material';
import {
  ArrowBackIosNewOutlined,
  ExpandLess,
  ExpandMore,
  StopCircleOutlined,
  LocalShippingOutlined,
  LowPriorityOutlined,
  VisibilityOutlined,
  VisibilityOffOutlined,
  BarChartOutlined,
  InfoOutlined,
  FormatListNumbered,
  StraightenOutlined,
  AccessTimeOutlined,
  RoomOutlined,
  ViewInArOutlined,
  EuroOutlined,
  ScaleOutlined,
  NumbersOutlined,
} from '@mui/icons-material';
import { makeStyles } from '@mui/styles';
import { alpha } from '@mui/material';
import { i18next } from '@/config/i18n';
import {
  Timeline,
  TimelineItem,
  TimelineSeparator,
  TimelineConnector,
  TimelineContent,
  TimelineDot,
  TimelineOppositeContent,
} from '@mui/lab';
import { katys100colors } from '@/components/Common/colorGen';
import { localTime } from '@/components/Common/timeUtils';
import { useSettings } from '@/components/Settings/SettingsContext';
import { useEditMode } from '@/contexts/EditModeContext';
import { setDayData } from '@/actions/routes/routesPure';
import VehicleRouteDetailsMap from '../VehicleRouteDetailsMap';
import {
  DndContext,
  DragEndEvent,
  DragStartEvent,
  DragCancelEvent,
  useDroppable,
  useSensor,
  useSensors,
  PointerSensor,
  TouchSensor,
  rectIntersection,
} from '@dnd-kit/core';
// @ts-ignore
import decodePolyline from 'decode-google-map-polyline';
import PendingShipmentsList from './PendingShipmentsList';
import DetailShipmentForm from '../Timeline/DetailShipmentForm';
import { getLoadClassData } from '@/common/common';
import Icon from '@/components/Common/Icons/Icon';
import * as Icons from '@/components/Common/Icons/Icons';

const HEADER_HEIGHT = 64;

const useStyles = makeStyles((theme: any) => ({
  vehicleContainer: {
    position: 'relative',
    width: '100%',
    height: `calc(100vh - ${HEADER_HEIGHT}px)`,
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden',
  },
  detailsMapcontainer: {
    position: 'relative',
    inset: 0,
    zIndex: 0,
    flex: 1,
  },
  routeListBox: {
    width: 436,
    height: '100%',
    overflow: 'hidden',
    backgroundColor: '#fff',
    zIndex: 1,
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 5,
    backgroundColor: '#fff',
  },

  wrapperCard: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    border: 0,
    borderRadius: 0,
    backgroundColor: '#fff',
  },
  headerBox: {
    border: '1px solid #ccc',
    padding: '0px',
  },
  vehcilename: {
    fontSize: '20px',
    marginLeft: '16px',
    fontWeight: '500',
  },
  card: {
    borderLeftWidth: 12,
    fontSize: '16px',
    padding: '8px 25px',
    borderBottom: '1px solid #ccc',
    cursor: 'pointer',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  highlightedStop: {
    backgroundColor: '#e0f3ff',
  },
  Listfirstbox: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    padding: '6px',
    borderBottom: '1px solid #ccc',
  },
  vehiclenametext: {
    fontWeight: 600,
    fontSize: '16px',
  },
  truckicon: {
    fontSize: '24px',
    marginRight: '10px',
  },
  Timelinecardbox: {
    flex: 1,
    overflowY: 'auto',
    scrollBehavior: 'smooth',
  },
  multiclr: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    width: 12,
  },
  tourtext: {
    fontSize: '16px',
    fontWeight: 500,
  },
  touridtext: {
    fontSize: '14px',
    fontWeight: 400,
  },
  expandclass: {
    padding: '10px 0px',
  },
  TimelineStart: {
    margin: '0px',
    padding: '0px',
  },
  TimelineOppositeContent: {
    flex: 0.2,
    padding: '16px 16px',
  },
  TimelineDot: {
    width: 32,
    height: 32,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  eyeonIcon: {
    fontSize: '20px',
    color: '#a3a1a1',
    marginLeft: '10px',
  },
  pendingHeader: {
    fontWeight: 600,
    marginBottom: 4,
  },
  pendingCard: {
    marginBottom: 8,
    backgroundColor: '#fafafa',
  },
  insertHandleRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '4px 0',
  },
  etaInvalid: {
    color: '#9e9e9e !important',
    opacity: 0.6,
  },
  summaryRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: 8,
    padding: '10px',
  },

  summaryChip: {
    height: 32,
    borderRadius: 999,
    backgroundColor: '#fff',
    border: '1px solid #bdbdbd',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: 13,
    fontWeight: 500,
    paddingLeft: 6,
    paddingRight: 6,
  },
}));

type AdhocStop = {
  id: string | number;
  type: string;
  location: { coordinates: { latitude: number; longitude: number } };
  shipments_to_load?: string[];
  shipments_to_unload?: string[];
  label?: string;
  tourId?: string;
  stopIndex?: number;
  showOnMap?: boolean;
  includeInETA?: boolean;
  includeInCapacity?: boolean;
};

interface Props {
  editMode?: boolean;
}

type TourSummary = {
  stopsCount: number | string;
  km: string;
  time: string;
  shipmentsCount: number | string;
  adrPoints: number;
};

function aggregateTours(tours: Array<any>): TourSummary {
  // Function utilities
  const formatTime = (totalMinutes: number): string => {
    if (!totalMinutes) return '--';
    const h = Math.floor(totalMinutes / 60);
    const m = totalMinutes % 60;
    return `${h} h ${m} min`;
  };
  const convertMeterToKm = (m: number): number => Math.round((m ?? 0) / 1000);

  // Initialize aggregate variables
  let stopsCount = 0;
  let total_distance_m = 0;
  let total_working_time_min = 0;
  let number_of_planned_shipments = 0;
  let adrPoints = 0;

  for (let tour of tours) {
    // stops fallback: count customer stops (exclude depot at 0)
    const stopsArr = Array.isArray(tour.stops) ? tour.stops : [];
    const effectiveStops = stopsArr.slice(
      stopsArr[0]?.type === 'depot' ? 1 : 0
    );

    // Aggregate logic: sum up stops, distance, and time across all tours
    stopsCount +=
      tour.summary.number_of_customer_stops ?? effectiveStops.length;
    total_distance_m += tour.summary.total_distance_m ?? 0;
    total_working_time_min += tour.summary.total_working_time_min ?? 0;
    number_of_planned_shipments +=
      tour.summary.number_of_planned_shipments ?? tour.shipments?.length ?? 0;

    (tour.shipments || []).forEach((s: any) => {
      adrPoints += s.adr_points || 0;
    });
  }

  return {
    stopsCount: stopsCount ?? '--',
    shipmentsCount: number_of_planned_shipments ?? '--',
    adrPoints,
    km:
      total_distance_m != null
        ? `${convertMeterToKm(total_distance_m)} km`
        : '-- km',
    time:
      total_working_time_min != null
        ? formatTime(total_working_time_min)
        : '--',
  };
}

const VehicleRoutes: React.FC = () => {
  const { vehicleName } = useParams();
  const dispatch = useDispatch();
  const [modalOpen, setModalOpen] = useState(false);
  const { editMode, setEditMode } = useEditMode();
  const [dirty, setDirty] = useState(false);
  const { selected_process } = useSelector((state: any) => state.core);
  const listRef = useRef<HTMLDivElement | null>(null);
  const [selectedStop, setSelectedStop] = useState<any>(null);
  const [etaInvalidFrom, setEtaInvalidFrom] = useState<
    Record<string, number | null>
  >({});
  const [stopContextMenu, setStopContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    tourId: string;
    // effective index = depot ke baad ka index (jo tum map me use kar rahe ho)
    stopEffectiveIndex: number;
  } | null>(null);
  const [moveDialog, setMoveDialog] = useState<{
    tourId: string;
    fromIndex: number;
  } | null>(null);

  const [targetPosition, setTargetPosition] = useState<number | ''>('');
  const [selectedShipments, setSelectedShipments] = useState<any[]>([]);
  const [selectedStopId, setSelectedStopId] = useState<string | number | null>(
    null
  );
  const [weightWatcherOpen, setWeightWatcherOpen] = useState(false);
  const [weightWatcherVehicle, setWeightWatcherVehicle] = useState<any>(null);
  // NEW: pending candidate selection for insertion
  const [pendingCandidate, setPendingCandidate] = useState<AdhocStop | null>(
    null
  );

  const classes = useStyles();
  const { optimization_data } = useSelector((state: any) => state.core);
  const getVehicleByName = React.useCallback(
    (name?: string) => {
      if (!optimization_data?.vehicles) return null;
      return (
        optimization_data.vehicles.find((v: any) => v.name === name) || null
      );
    },
    [optimization_data]
  );
  const { pendingAssignments = {}, assignedIds = [] } =
    useSelector((state: any) => state.routes) ?? {};
  const pendingShipmentsForVehicle: any[] = Array.isArray(
    pendingAssignments?.[vehicleName as string]
  )
    ? pendingAssignments[vehicleName as string]
    : [];
  const routeMap = optimization_data?.routes || {};
  const navigate = useNavigate();
  const location = useLocation();
  const { settings } = useSettings();
  const dimensions: {
    dimension?: string;
    unit?: string;
    backendIndex?: number;
  }[] = settings.load_dimensions || [];

  const resolvedDimensions = useMemo(
    () =>
      dimensions.map((d, idx) => {
        if (d.backendIndex != null) return d;

        const n = (d.dimension || '').toLowerCase();
        let backendIndex = idx; // default fallback

        if (n.includes('adr')) backendIndex = 2;
        else if (n.includes('m3') || n.includes('cbm') || n.includes('vol'))
          backendIndex = 2;
        else if (
          n.includes('stell') ||
          n.includes('slot') ||
          n.includes('palett') ||
          n.includes('stpl')
        )
          backendIndex = 1;
        else if (
          n.includes('gewicht') ||
          n.includes('weight') ||
          n.includes('kg')
        )
          backendIndex = 0;

        return { ...d, backendIndex };
      }),
    [dimensions]
  );

  const [removedPendingIds, setRemovedPendingIds] = useState<Set<string>>(
    new Set()
  );
  const PENDING_LS_KEY = useMemo(
    () => `pending_${String(selected_process?.optimization_id || 'default')}`,
    [selected_process?.optimization_id]
  );

  const filteredPendingShipmentsForVehicle = useMemo(
    () =>
      (pendingShipmentsForVehicle || []).filter(
        (s: any) => !removedPendingIds.has(String(s.custom_id))
      ),
    [pendingShipmentsForVehicle, removedPendingIds]
  );
  // Original tours from store
  const storeTours = Array.isArray(routeMap[vehicleName])
    ? routeMap[vehicleName]
    : [];

  const hydratedRef = useRef(false);
  // keep header in sync for unsaved-changes dialog
  useEffect(() => {
    (window as any).__routes_dirty__ = dirty;
    return () => {
      (window as any).__routes_dirty__ = false;
    };
  }, [dirty]);

  useEffect(() => {
    try {
      const hasStoreData =
        (pendingAssignments && Object.keys(pendingAssignments).length > 0) ||
        (Array.isArray(assignedIds) && assignedIds.length > 0);
      if (hasStoreData) return;

      const raw = localStorage.getItem(PENDING_LS_KEY);
      if (!raw) return;

      const parsed = JSON.parse(raw);
      const lsPending =
        parsed &&
        typeof parsed === 'object' &&
        typeof parsed.pendingAssignments === 'object'
          ? parsed.pendingAssignments
          : {};
      const lsAssigned = Array.isArray(parsed?.assignedIds)
        ? parsed.assignedIds
        : [];

      const nextPending = { ...(pendingAssignments || {}), ...lsPending };
      const nextAssigned = lsAssigned.length ? lsAssigned : assignedIds || [];

      if (Object.keys(nextPending).length || nextAssigned.length) {
        dispatch(
          setDayData({
            pendingAssignments: nextPending,
            assignedIds: nextAssigned,
          })
        );
      }
    } catch {
    } finally {
      hydratedRef.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [PENDING_LS_KEY]);

  useEffect(() => {
    if (!hydratedRef.current) return;
    try {
      localStorage.setItem(
        PENDING_LS_KEY,
        JSON.stringify({ pendingAssignments, assignedIds })
      );
    } catch {}
  }, [
    PENDING_LS_KEY,
    JSON.stringify(pendingAssignments),
    JSON.stringify(assignedIds),
  ]);

  const sensors = useSensors(
    // Mouse/pen
    useSensor(PointerSensor, {
      activationConstraint: { distance: 5 },
    }),
    // Touch
    useSensor(TouchSensor, {
      activationConstraint: { delay: 150, tolerance: 5 },
    })
  );

  const DropSlot: React.FC<{ id: string; label?: string }> = ({
    id,
    label,
  }) => {
    const { isOver, setNodeRef } = useDroppable({ id });
    return (
      <Box
        ref={setNodeRef}
        sx={{
          my: 1,
          px: 1.5,
          py: 1,
          minHeight: 32,
          borderRadius: 1,
          border: '1px dashed',
          borderColor: isOver ? 'primary.main' : 'grey.300',
          bgcolor: isOver ? 'action.hover' : 'transparent',
          textAlign: 'center',
          fontSize: 12,
          cursor: 'copy',
          userSelect: 'none',
          position: 'relative',
          zIndex: 2,
        }}
      >
        {label ?? i18next.t('common:PendingShipments.dropHere')}
      </Box>
    );
  };

  // DnD — show insert handles while dragging a pending card
  const onDragStart = (e: DragStartEvent) => {
    const data = e.active.data?.current as any;
    if (data?.type === 'PENDING_ADHOC') {
      const found = adhocStops.find(
        (a) => String(a.id) === String(data.adhocId)
      );
      if (found) setPendingCandidate(found);
    }
  };

  const onDragCancel = (_e: DragCancelEvent) => {
    setPendingCandidate(null);
  };

  const onDragEnd = (e: DragEndEvent) => {
    const data = e.active.data?.current as any;
    if (data?.type !== 'PENDING_ADHOC') {
      setPendingCandidate(null);
      return;
    }

    const overId = e.over?.id ? String(e.over.id) : '';
    if (!overId) {
      setPendingCandidate(null);
      return;
    }

    const [prefix, tourId, indexStr] = overId.split('::');

    // drop on tour header -> unsequenced bucket
    if (prefix === 'unscheduled' && tourId) {
      if (pendingCandidate) {
        // 1) UI: add to tour.unsequenced_shipments
        setUiTours((prev) => {
          const next = prev.map((t) => ({ ...t }));
          const tIdx = next.findIndex((t) => t.id === tourId);
          if (tIdx < 0) return next;

          const idsAtStop = [
            ...(pendingCandidate.shipments_to_load || []),
            ...(pendingCandidate.shipments_to_unload || []),
          ].map(String);

          const pendingObjs = (pendingShipmentsForVehicle || []).filter(
            (s: any) => idsAtStop.includes(String(s.custom_id))
          );

          const tour = next[tIdx];
          tour.unsequenced_shipments = Array.isArray(tour.unsequenced_shipments)
            ? [...tour.unsequenced_shipments, ...pendingObjs]
            : [...pendingObjs];

          const tourShipments: any[] = Array.isArray(tour.shipments)
            ? [...tour.shipments]
            : [];
          const existing = new Set(
            tourShipments.map((s: any) => String(s.custom_id))
          );
          pendingObjs.forEach((s: any) => {
            const id = String(s.custom_id ?? '');
            if (id && !existing.has(id)) tourShipments.push(s);
          });
          tour.shipments = tourShipments;

          return next;
        });

        // 2) PendingAssignments se nikaal do
        try {
          const idsAtStop = [
            ...(pendingCandidate.shipments_to_load || []),
            ...(pendingCandidate.shipments_to_unload || []),
          ].map(String);

          const currentForVeh = Array.isArray(
            pendingAssignments?.[vehicleName as string]
          )
            ? pendingAssignments[vehicleName as string]
            : [];
          const prunedForVeh = currentForVeh.filter(
            (s: any) => !idsAtStop.includes(String(s.custom_id))
          );

          dispatch(
            setDayData({
              pendingAssignments: {
                ...pendingAssignments,
                [vehicleName as string]: prunedForVeh,
              },
              assignedIds: (assignedIds || []).filter(
                (id: string) => !idsAtStop.includes(String(id))
              ),
            })
          );
        } catch {}

        setDirty(true);
        setPendingCandidate(null);
      }
      return;
    }

    // index based insert
    if (prefix === 'slot' && tourId && indexStr) {
      const index = Number(indexStr);
      if (Number.isFinite(index)) insertAt(tourId, index);
    }
    setPendingCandidate(null);
  };

  const [uiTours, setUiTours] = useState<any[]>(storeTours);
  useEffect(() => {
    if (!dirty) setUiTours(storeTours);
  }, [vehicleName, JSON.stringify(storeTours)]);

  const tours = uiTours;

  const allVehicleIds = Object.keys(routeMap).sort((a, b) =>
    a.toLowerCase().localeCompare(b.toLowerCase())
  );
  const vehicleIndex = allVehicleIds.findIndex(
    (id) => id.toLowerCase() === vehicleName?.toLowerCase()
  );
  const defaultRouteColor =
    vehicleIndex >= 0
      ? katys100colors[vehicleIndex % katys100colors.length]
      : '#1976d2';
  const pendingForThisVehicle = filteredPendingShipmentsForVehicle.length;

  const handleSave = useCallback(() => {
    const payload = (uiTours || []).map((t: any) => ({
      id: t.id,
      polyline: t.polyline,
      shipments: Array.isArray(t.shipments) ? t.shipments : [],
      unsequenced_shipments: Array.isArray(t.unsequenced_shipments)
        ? t.unsequenced_shipments
        : [],
      stops: (t.stops || []).map((s: any, idx: number) => ({
        id: s.id || s.idNumber || `${t.id}-${idx}`,
        type: s.type,
        location: s.location ?? null,
        shipments_to_load: s.shipments_to_load || [],
        shipments_to_unload: s.shipments_to_unload || [],
        meta: s.meta || {},
        showOnMap: s.showOnMap !== false,
        includeInETA: s.includeInETA !== false,
        includeInCapacity: s.includeInCapacity !== false,
      })),
    }));

    if (vehicleName) {
      localStorage.setItem(
        `demo_routes_${vehicleName}`,
        JSON.stringify(payload)
      );
    }
    try {
      localStorage.setItem(
        PENDING_LS_KEY,
        JSON.stringify({ pendingAssignments, assignedIds })
      );
    } catch {}

    setDirty(false);
    setEditMode(false);
  }, [
    uiTours,
    vehicleName,
    setDirty,
    setEditMode,
    PENDING_LS_KEY,
    pendingAssignments,
    assignedIds,
  ]);

  const handleCancel = useCallback(() => {
    setDirty(false);
    setEditMode(false);
    setUiTours(storeTours);
    setPendingCandidate(null);
    navigate(-1);
  }, [navigate, setEditMode, storeTours]);

  const getStopId = (stop: any, idx?: number, tourId?: string) => {
    return stop?.id || stop?.idNumber || `${tourId}-${idx}`;
  };

  const [expandedTours, setExpandedTours] = useState<Record<string, boolean>>(
    tours.reduce((acc: any, tour: any) => {
      acc[tour.id] = true;
      return acc;
    }, {})
  );

  const vehicleLoadClass = useMemo(() => {
    const veh = getVehicleByName(vehicleName as string);
    return getLoadClassData(veh);
  }, [getVehicleByName, vehicleName]);

  const [openDetails, setOpenDetails] = useState<Record<string, boolean>>({});
  const scrollWithOffset = (el: HTMLElement, offset = 60) => {
    const top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    window.scrollTo({ top, behavior: 'smooth' });
  };

  useEffect(() => {
    const newExpandedTours = tours.reduce((acc: any, tour: any) => {
      acc[tour.id] = true;
      return acc;
    }, {});
    setExpandedTours(newExpandedTours);
  }, [vehicleName, tours]);

  const getFrontendLabelByBackendIndex = (backendIndex: number) => {
    const byBackend = resolvedDimensions.find(
      (d) => d.backendIndex === backendIndex
    );
    if (byBackend) return byBackend;
    return resolvedDimensions[backendIndex] || {};
  };

  const toggleExpand = (id: string, e: React.MouseEvent) => {
    e.stopPropagation();
    setExpandedTours((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const [visibleTours, setVisibleTours] = useState<Record<string, boolean>>(
    tours.reduce(
      (acc, tour) => {
        acc[tour.id] = true;
        return acc;
      },
      {} as Record<string, boolean>
    )
  );

  const summaryTour = useMemo(() => {
    // TODO: Probably needs to be removed
    if (!tours || tours.length === 0) return null;

    // 1) if a stop is selected, try to use its tourId
    const selectedTourId = (selectedStop as any)?.tourId;
    if (selectedTourId) {
      const t = tours.find((x: any) => String(x.id) === String(selectedTourId));
      if (t) return t;
    }

    // 2) if only one tour, use it
    if (tours.length === 1) return tours[0];

    // 3) fallback: first visible tour if visibility map exists
    const firstVisible = tours.find((t: any) => visibleTours?.[t.id] !== false);
    return firstVisible || tours[0];
  }, [tours, selectedStop, visibleTours]);

  const headerSummary = useMemo(() => {
    if (!summaryTour) {
      return {
        km: '--',
        time: '--',
        stops: '--',
        shipments: '--',
        loadClass: '--',
      };
    }

    const s = (summaryTour.summary || {}) as any;

    const aggregatedTours = aggregateTours(tours);

    // TODO: load class logic also needs to be go to aggregated Tours
    return {
      km: aggregatedTours.km,
      time: aggregatedTours.time,
      stops: aggregatedTours.stopsCount,
      shipments: aggregatedTours.shipmentsCount,
      adrPoints: aggregatedTours.adrPoints,
      loadClass:
        summaryTour.load_class ?? s.load_class ?? vehicleLoadClass ?? '--',
    };
  }, [tours, summaryTour, vehicleLoadClass]);

  useEffect(() => {
    setVisibleTours(
      tours.reduce(
        (acc, tour) => {
          acc[tour.id] = true;
          return acc;
        },
        {} as Record<string, boolean>
      )
    );
  }, [vehicleName, tours]);

  useEffect(() => {
    if (selectedStop?.id) {
      setTimeout(() => {
        const el = document.getElementById(`stop-${selectedStop.id}`);
        const scrollContainer = listRef.current;

        if (el && scrollContainer) {
          const elTop = el.offsetTop;
          const scrollTop = elTop - 60;

          scrollContainer.scrollTo({
            top: scrollTop,
            behavior: 'smooth',
          });
        }
      }, 100);
    }
  }, [selectedStop]);

  useEffect(() => {
    if (vehicleName && tours.length) {
      const polylineData: Record<string, any[]> = {
        [vehicleName]: tours
          .filter(
            (t) => typeof t.polyline === 'string' && t.polyline.length > 0
          )
          .map((t) => ({
            id: t.id,
            coords: decodePolyline(t.polyline).map((p: any) => [p.lat, p.lng]),
          })),
      };
      //@ts-ignore
      dispatch(setRouteStrings(polylineData));
    }
  }, [vehicleName, tours]);

  const tourColorsById: Record<string, string> = useMemo(() => {
    const colors: Record<string, string> = {};
    let colorIndex = 0;
    Object.entries(routeMap).forEach(([vehicleId, vehicleTours]) => {
      if (Array.isArray(vehicleTours)) {
        vehicleTours.forEach((tour: any) => {
          if (tour?.id) {
            colors[tour.id] =
              katys100colors[colorIndex % katys100colors.length];
            colorIndex++;
          }
        });
      }
    });
    return colors;
  }, [routeMap]);

  const routeColor =
    tours.length === 1
      ? tourColorsById[tours[0]?.id] || defaultRouteColor
      : (location.state as any)?.routeColor || defaultRouteColor;

  // Build adhoc/pending stops for map
  const adhocStops = useMemo<AdhocStop[]>(() => {
    return (filteredPendingShipmentsForVehicle || []).map(
      (shipment: any, idx: number) => {
        const c = shipment?.location?.coordinates;
        const lat = c?.latitude ?? c?.lat;
        const lng = c?.longitude ?? c?.lng;
        const hasCoords =
          typeof lat === 'number' &&
          typeof lng === 'number' &&
          !isNaN(lat) &&
          !isNaN(lng);

        const typeLower = String(shipment.type || '').toLowerCase();
        const isPickup = typeLower === 'pickup';
        const isDelivery = typeLower === 'delivery';

        return {
          id: `pending-${shipment.custom_id || idx}`,
          type: shipment.type || 'unscheduled_pending',
          ...(hasCoords
            ? { location: { coordinates: { latitude: lat, longitude: lng } } }
            : {}),
          shipments_to_load: isPickup ? [String(shipment.custom_id)] : [],
          shipments_to_unload: isDelivery ? [String(shipment.custom_id)] : [],
          tourId: 'UNPLANNED',
          stopIndex: idx,
          showOnMap: hasCoords,
          includeInETA: hasCoords,
          includeInCapacity: true,
        } as AdhocStop;
      }
    );
  }, [filteredPendingShipmentsForVehicle]);

  // build stop obj from pending candidate
  const buildStopFromPending = (p: AdhocStop) => ({
    id: `temp-${p.id}`,
    type: p.type || 'unscheduled_pending',
    location: p.location,
    shipments_to_load: p.shipments_to_load ?? [],
    shipments_to_unload: p.shipments_to_unload ?? [],
    showOnMap: p.showOnMap ?? false,
    includeInETA: p.includeInETA ?? false,
    includeInCapacity: p.includeInCapacity ?? true,
    meta: {
      provisional: true,
      source: 'pending',
      pending_id: p.id,
      inserted_at: Date.now(),
    },
  });

  const InsertHandle: React.FC<{ onClick: () => void; label: string }> = ({
    onClick,
    label,
  }) => (
    <Box className={classes.insertHandleRow}>
      <Button size="small" variant="outlined" onClick={onClick}>
        + Insert {label}
      </Button>
    </Box>
  );

  // insert logic (optimistic UI) + set grey-out index
  const insertAt = (tourId: string, index: number) => {
    if (!pendingCandidate) return;

    const newStop = buildStopFromPending(pendingCandidate);

    const idsAtStop = [
      ...(newStop.shipments_to_load || []),
      ...(newStop.shipments_to_unload || []),
    ].map(String);

    const primaryId = idsAtStop[0];
    // we need the actual inserted index (with depot considered)
    let insertedIndex = -1;

    // 1) UI update
    setUiTours((prev) => {
      const next = prev.map((t) => ({
        ...t,
        stops: Array.isArray(t.stops) ? [...t.stops] : [],
      }));
      const tIdx = next.findIndex((t) => t.id === tourId);
      if (tIdx < 0) return next;

      const tour = next[tIdx];

      // ensure shipments carry over
      const pendingShipmentObjs = (pendingShipmentsForVehicle || []).filter(
        (s: any) => idsAtStop.includes(String(s.custom_id))
      );
      const tourShipments: any[] = Array.isArray(tour.shipments)
        ? [...tour.shipments]
        : [];
      const existingIds = new Set(
        tourShipments.map((s: any) => String(s.custom_id))
      );
      pendingShipmentObjs.forEach((s: any) => {
        const id = String(s?.custom_id ?? '');
        if (id && !existingIds.has(id)) {
          tourShipments.push(s);
          existingIds.add(id);
        }
      });
      tour.shipments = tourShipments;

      // insert stop (skip depot at 0)
      const hasDepotAt0 = tour.stops?.[0]?.type === 'depot';
      const rawIndex = hasDepotAt0 ? index + 1 : index;
      const safeIndex = Math.max(0, Math.min(rawIndex, tour.stops.length));
      const prevStop = tour.stops[safeIndex - 1];
      const nextStop = tour.stops[safeIndex];

      (newStop as any).meta = {
        ...((newStop as any).meta || {}),
        provisional: true,
        source: 'pending',
        prevStopId: prevStop
          ? getStopId(prevStop, safeIndex - 1, tourId)
          : null,
        nextStopId: nextStop ? getStopId(nextStop, safeIndex, tourId) : null,
      };

      tour.stops.splice(safeIndex, 0, newStop);

      // remember where we actually inserted
      insertedIndex = safeIndex;
      return next;
    });

    // 2) grey out all ETAs after the inserted index
    if (insertedIndex >= 0) {
      setEtaInvalidFrom((prev) => ({
        ...prev,
        [tourId]: insertedIndex,
      }));
    }
    setDirty(true);
    try {
      const currentForVeh = Array.isArray(
        pendingAssignments?.[vehicleName as string]
      )
        ? pendingAssignments[vehicleName as string]
        : [];

      const prunedForVeh = currentForVeh.filter(
        (s: any) => !idsAtStop.includes(String(s.custom_id))
      );

      dispatch(
        setDayData({
          pendingAssignments: {
            ...pendingAssignments,
            [vehicleName as string]: prunedForVeh,
          },
          assignedIds: (assignedIds || []).filter(
            (id: string) => !idsAtStop.includes(String(id))
          ),
        })
      );
    } catch {}

    if (primaryId) {
      setRemovedPendingIds((prev) => new Set(prev).add(String(primaryId)));
    }
    setPendingCandidate(null);
  };

  const moveStopInTour = (
    tourId: string,
    fromEffectiveIdx: number,
    toEffectiveIdx: number
  ) => {
    setUiTours((prev) => {
      const next = prev.map((t) => ({
        ...t,
        stops: Array.isArray(t.stops) ? [...t.stops] : [],
      }));
      const tour = next.find((t) => t.id === tourId);
      if (!tour) return next;

      const hasDepotAt0 = tour.stops?.[0]?.type === 'depot';
      // effectiveIdx 0 = UI me jo pehla stop dikh raha (agar depot hai to actually index 1)
      const fromReal = hasDepotAt0 ? fromEffectiveIdx + 1 : fromEffectiveIdx;
      const toReal = hasDepotAt0 ? toEffectiveIdx + 1 : toEffectiveIdx;

      if (
        fromReal < 0 ||
        fromReal >= tour.stops.length ||
        toReal < 0 ||
        toReal >= tour.stops.length
      ) {
        return next;
      }

      const item = tour.stops.splice(fromReal, 1)[0];
      tour.stops.splice(toReal, 0, item);

      // ETA invalidate from chhote wale index se
      const invalidateFrom = Math.min(fromReal, toReal);
      setEtaInvalidFrom((prevEta) => ({
        ...prevEta,
        [tourId]: invalidateFrom,
      }));

      return next;
    });

    setDirty(true);
  };

  useEffect(() => {
    const onHeaderSave = () => handleSave();
    const onHeaderDiscard = () => handleCancel();
    window.addEventListener('routes:header-save' as any, onHeaderSave);
    window.addEventListener('routes:header-discard' as any, onHeaderDiscard);
    return () => {
      window.removeEventListener('routes:header-save' as any, onHeaderSave);
      window.removeEventListener(
        'routes:header-discard' as any,
        onHeaderDiscard
      );
    };
  }, [handleSave, handleCancel]);

  useEffect(() => {
    const raw = localStorage.getItem(`demo_routes_${vehicleName}`);
    if (!raw) return;
    try {
      const saved = JSON.parse(raw);
      if (Array.isArray(saved) && saved.length) {
        const byIdStore: Record<string, any> = {};
        (storeTours || []).forEach((t: any) => {
          if (t?.id) byIdStore[t.id] = t;
        });

        const hydrated = saved.map((t: any) => {
          const storeT = byIdStore[t.id] || {};
          return {
            ...t,
            shipments: Array.isArray(t.shipments)
              ? t.shipments
              : storeT.shipments || [],
            unsequenced_shipments: Array.isArray(t.unsequenced_shipments)
              ? t.unsequenced_shipments
              : storeT.unsequenced_shipments || [],
          };
        });

        setUiTours(hydrated);
      }
    } catch {}
  }, [vehicleName]);

  return (
    <Box className={classes.vehicleContainer}>
      <Box className={classes.detailsMapcontainer}>
        {tours.length > 0 && (
          <VehicleRouteDetailsMap
            polylines={tours
              .filter((t) => visibleTours[t.id])
              .map((t) => ({ id: t.id, polyline: t.polyline }))}
            visibleTours={visibleTours}
            setVisibleTours={setVisibleTours}
            stops={tours
              .filter((t) => visibleTours[t.id])
              .flatMap((t: any) =>
                (t.stops || []).map((s: any, idx: number) => ({
                  ...s,
                  id: getStopId(s, idx, t.id),
                  tourId: t.id,
                  stopIndex: idx,
                }))
              )}
            routeColors={tourColorsById}
            companyLocation={optimization_data?.location?.coordinates}
            selectedStopId={selectedStopId}
            onStopClick={(stop) => {
              const stopId = getStopId(stop);
              const tourId = stop.tourId;
              setSelectedStop({ ...stop, id: stopId });
              setSelectedStopId(stopId);
              if (tourId && tourId !== 'PENDING') {
                setExpandedTours((prev) => ({
                  ...prev,
                  [tourId]: true,
                }));
                setVisibleTours((prev) => ({ ...prev, [tourId]: true }));
              }
            }}
            onStopDoubleClick={(stop) => {
              const stopId = getStopId(stop);
              if (stop.tourId === 'PENDING') {
                const pendingShipments = pendingShipmentsForVehicle.filter(
                  (s: any) =>
                    [
                      ...(stop.shipments_to_unload || []),
                      ...(stop.shipments_to_load || []),
                    ]
                      .map(String)
                      .includes(String(s.custom_id))
                );
                setSelectedStop({ ...stop, id: stopId });
                setSelectedStopId(stopId);
                setSelectedShipments(pendingShipments);
                setModalOpen(true);
                return;
              }

              const tour = tours.find((t: any) => t.id === stop.tourId);
              const shipmentsById: Record<string, any> = {};
              (tour?.shipments || []).forEach((s: any) => {
                if (s.custom_id) shipmentsById[s.custom_id] = s;
              });

              const shipments = [
                ...(stop.shipments_to_unload || []),
                ...(stop.shipments_to_load || []),
              ]
                .map((id: string) => shipmentsById[id])
                .filter(Boolean);

              setSelectedStop({ ...stop, id: stopId });
              setSelectedStopId(stopId);
              setSelectedShipments(shipments);
              setModalOpen(true);
            }}
            adhocStops={adhocStops}
            editMode={editMode}
          />
        )}
      </Box>

      <Box className={classes.routeListBox}>
        <DndContext
          sensors={sensors}
          collisionDetection={rectIntersection}
          onDragStart={onDragStart}
          onDragEnd={onDragEnd}
          onDragCancel={onDragCancel}
        >
          <Card variant="outlined" className={classes.wrapperCard}>
            <Box className={classes.stickyHeader}>
              <CardContent
                className={classes.headerBox}
                sx={{
                  paddingBottom: 0,
                  '&.MuiCardContent-root:last-child': {
                    paddingBottom: '0px !important',
                  },
                }}
              >
                <Box className={classes.Listfirstbox} sx={{ padding: 0 }}>
                  <Box display="flex" alignItems="center" gap={1}>
                    <IconButton onClick={() => navigate(-1)}>
                      <ArrowBackIosNewOutlined fontSize="medium" />
                    </IconButton>
                    <Typography
                      variant="subtitle2"
                      className={classes.vehiclenametext}
                    >
                      {vehicleName}
                      {headerSummary.loadClass !== '--' && (
                        <Box
                          component="span"
                          sx={{
                            ml: 1.5,
                            fontWeight: 500,
                            fontSize: '15px',
                            color: 'text.secondary',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                          }}
                        >
                          {headerSummary.loadClass}
                        </Box>
                      )}
                      {pendingForThisVehicle > 0 && (
                        <Box
                          component="span"
                          sx={{ ml: 1, color: 'success.main', fontWeight: 700 }}
                        >
                          (+{pendingForThisVehicle})
                        </Box>
                      )}
                      {pendingCandidate && (
                        <Box
                          component="span"
                          sx={{
                            ml: 1,
                            px: 1,
                            py: 0.25,
                            borderRadius: 1,
                            bgcolor: 'warning.light',
                            color: 'warning.contrastText',
                            fontWeight: 700,
                            fontSize: '12px',
                          }}
                        >
                          {i18next.t('common:PendingShipments.inserting')}
                        </Box>
                      )}
                    </Typography>
                  </Box>
                  <Box display="flex" alignItems="center" sx={{ gap: 1 }}>
                    <IconButton
                      size="small"
                      onClick={() => {
                        const veh = getVehicleByName(vehicleName as string);
                        setWeightWatcherVehicle(veh);
                        setWeightWatcherOpen(true);
                      }}
                    >
                      <BarChartOutlined />
                    </IconButton>
                    <LocalShippingOutlined className={classes.truckicon} />
                  </Box>
                </Box>
                <Box className={classes.summaryRow}>
                  <Chip
                    className={classes.summaryChip}
                    icon={<AccessTimeOutlined />}
                    label={headerSummary.time}
                  />
                  <Chip
                    className={classes.summaryChip}
                    icon={<RoomOutlined />}
                    label={`${headerSummary.stops} Stops`}
                  />
                  <Chip
                    className={classes.summaryChip}
                    icon={<ViewInArOutlined />}
                    label={`${headerSummary.shipments} Aufträge`}
                  />
                  <Chip
                    className={classes.summaryChip}
                    icon={<StraightenOutlined />}
                    label={headerSummary.km}
                  />
                  {headerSummary.adrPoints > 0 && (
                    <Chip
                      className={classes.summaryChip}
                      icon={
                        <Icon
                          svg={Icons.adrMono}
                          viewBox="0 0 103.5 103.425"
                          sx={{
                            fontSize: '24px',
                            color: 'inherit',
                            stroke: 'currentColor',
                            strokeWidth: 4,
                          }}
                        />
                      }
                      label={headerSummary.adrPoints}
                    />
                  )}

                </Box>
              </CardContent>
            </Box>

            <Box ref={listRef} className={classes.Timelinecardbox}>
              {filteredPendingShipmentsForVehicle.length > 0 && (
                <PendingShipmentsList
                  shipments={filteredPendingShipmentsForVehicle}
                  adhocStops={adhocStops}
                  selectedId={pendingCandidate?.id}
                  classNames={{
                    header: classes.pendingHeader,
                    card: classes.pendingCard,
                  }}
                  onPick={(found) => {
                    setSelectedStop(found);
                    setSelectedStopId(found.id);
                    setPendingCandidate(found);
                  }}
                />
              )}

              {tours.map((tour: any) => {
                const shipmentsById: Record<string, any> = {};
                (tour.shipments || []).forEach((s: any) => {
                  const id = String(s?.custom_id ?? '');
                  if (id) shipmentsById[id] = s;
                });

                const stops = tour.stops || [];
                const depotStop =
                  stops.find((s: any) => s?.type === 'depot') || null;
                const depotStartISO =
                  depotStop?.departure_time ||
                  depotStop?.arrival_time ||
                  tour?.start_time ||
                  null;

                const depotStartLabel = depotStartISO
                  ? localTime(new Date(depotStartISO)) // "HH:MM"
                  : '--';

                // depot address: stop.location.address nahi hota to optimization_data.depot_location use kar lo
                const depotAddr =
                  depotStop?.location?.address ||
                  optimization_data?.depot_location?.address ||
                  null;

                const depotAddressString = depotAddr
                  ? [
                      [depotAddr.street, depotAddr.house_number]
                        .filter(Boolean)
                        .join(' ')
                        .trim(),
                      [depotAddr.postal_code, depotAddr.city]
                        .filter(Boolean)
                        .join(' ')
                        .trim(),
                      depotAddr.country,
                    ]
                      .filter(Boolean)
                      .join(', ')
                  : '--';
                const effectiveStops = stops
                  .map((stop: any, indexInTour: number) => ({
                    ...stop,
                    id: getStopId(stop, indexInTour, tour.id),
                    stopIndex: indexInTour,
                    tourId: tour.id,
                  }))
                  .slice(stops[0]?.type === 'depot' ? 1 : 0);

                // get invalid-from index for this tour
                const invalidFrom = etaInvalidFrom[tour.id] ?? null;

                return (
                  <Box key={tour.id} style={{ borderTop: '1px solid #ccc' }}>
                    <Box
                      className={classes.card}
                      onClick={(e) => toggleExpand(tour.id, e)}
                    >
                      <Box
                        className={classes.multiclr}
                        style={{
                          backgroundColor:
                            tours.length === 1
                              ? routeColor
                              : tourColorsById[tour.id] || defaultRouteColor,
                        }}
                      />
                      <Typography variant="h6">
                        <Box component="span" className={classes.tourtext}>
                          Tour
                        </Box>{' '}
                        <Box component="span" className={classes.touridtext}>
                          {tour.id}
                          {tours.length > 1 && (
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                setVisibleTours((prev) => ({
                                  ...prev,
                                  [tour.id]: !prev[tour.id],
                                }));
                              }}
                            >
                              {visibleTours[tour.id] ? (
                                <VisibilityOutlined
                                  className={classes.eyeonIcon}
                                />
                              ) : (
                                <VisibilityOffOutlined
                                  className={classes.eyeonIcon}
                                />
                              )}
                            </IconButton>
                          )}
                        </Box>
                      </Typography>
                      <IconButton size="small">
                        {expandedTours[tour.id] ? (
                          <ExpandLess />
                        ) : (
                          <ExpandMore />
                        )}
                      </IconButton>
                    </Box>

                    {expandedTours[tour.id] && (
                      <Box className={classes.expandclass}>
                        {pendingCandidate && (
                          <>
                            <InsertHandle
                              onClick={() => insertAt(tour.id, 0)}
                              label={i18next.t(
                                'common:PendingShipments.atBeginning'
                              )}
                            />
                            <DropSlot
                              id={`unscheduled::${tour.id}`}
                              label={i18next.t(
                                'common:PendingShipments.dropToUnsequenced'
                              )}
                            />
                          </>
                        )}

                        <Timeline
                          className={classes.TimelineStart}
                          position="right"
                        >
                          {/* DEPOT start row */}
                          {depotStop && (
                            <TimelineItem
                              id={`stop-depot-${tour.id}`}
                              onClick={() => {
                                const depotId = `depot-${tour.id}`;
                                setSelectedStop({
                                  ...depotStop,
                                  id: depotId,
                                  tourId: tour.id,
                                  stopIndex: 0,
                                });
                                setSelectedStopId(depotId);
                              }}
                            >
                              <TimelineOppositeContent
                                className={classes.TimelineOppositeContent}
                              >
                                <Typography variant="caption">
                                  {depotStartLabel}
                                </Typography>
                              </TimelineOppositeContent>

                              <TimelineSeparator>
                                <TimelineDot
                                  className={classes.TimelineDot}
                                  sx={{
                                    bgcolor: 'grey.400',
                                    boxShadow: `0 0 0 8px ${alpha(
                                      '#9e9e9e',
                                      0.26
                                    )}`,
                                  }}
                                >
                                  <StopCircleOutlined
                                    fontSize="small"
                                    sx={{ color: '#fff' }}
                                  />
                                </TimelineDot>

                                {/* connector if there are stops after depot */}
                                {effectiveStops.length > 0 && (
                                  <TimelineConnector
                                    sx={{ bgcolor: 'grey.400', width: 2 }}
                                  />
                                )}
                              </TimelineSeparator>

                              <TimelineContent sx={{ py: 1, pl: 2 }}>
                                <Typography
                                  variant="body2"
                                  sx={{
                                    fontWeight: 400,
                                    fontSize: '13px',
                                    lineHeight: '39px',
                                  }}
                                >
                                  DEPOT
                                </Typography>
                              </TimelineContent>
                            </TimelineItem>
                          )}
                          {effectiveStops.map((stop: any, idx: number) => {
                            const shipments = [
                              ...(stop.shipments_to_unload || []),
                              ...(stop.shipments_to_load || []),
                            ]
                              .map(
                                (id: string | number) =>
                                  shipmentsById[String(id)]
                              )
                              .filter(Boolean);

                            const stopETA = stop.arrival_time
                              ? `${localTime(new Date(stop.arrival_time))}`
                              : `Stop ${idx + 1}`;
                            const detailKey = `${tour.id}-${idx}`;
                            const stopId = stop.id;

                            // check if this ETA is invalid
                            const isEtaInvalid =
                              invalidFrom !== null &&
                              stop.stopIndex >= invalidFrom;

                            return (
                              <React.Fragment key={stopId}>
                                <TimelineItem
                                  id={`stop-${stopId}`}
                                  className={`${
                                    selectedStopId === stopId
                                      ? classes.highlightedStop
                                      : ''
                                  }`}
                                  onClick={() => {
                                    setSelectedStop({ ...stop, id: stopId });
                                    setSelectedStopId(stopId);
                                  }}
                                  onContextMenu={(e) => {
                                    e.preventDefault();
                                    // yahan store kar lo kahan click hua aur kaunsa stop tha
                                    setStopContextMenu({
                                      mouseX: e.clientX + 2,
                                      mouseY: e.clientY - 6,
                                      tourId: tour.id,
                                      stopEffectiveIndex: idx, // yeh woh idx hai jo effectiveStops.map se aa raha
                                    });
                                  }}
                                >
                                  <TimelineOppositeContent
                                    className={`${
                                      classes.TimelineOppositeContent
                                    } ${
                                      isEtaInvalid ? classes.etaInvalid : ''
                                    }`}
                                  >
                                    <Typography
                                      variant="caption"
                                      className={
                                        isEtaInvalid ? classes.etaInvalid : ''
                                      }
                                    >
                                      {stopETA}
                                    </Typography>
                                  </TimelineOppositeContent>

                                  <TimelineSeparator>
                                    {(() => {
                                      const typesAtStop = new Set(
                                        shipments.map((s: any) => s?.type)
                                      );
                                      const isPickup =
                                        typesAtStop.has('pickup');
                                      const isDelivery =
                                        typesAtStop.has('delivery');

                                      let dotColor = '#ccc';
                                      let dotBg = undefined;
                                      let boxShadowColor = alpha('#ccc', 0.26);

                                      if (isPickup && isDelivery) {
                                        dotBg = `linear-gradient(135deg, #ef5350 50%, #0288d1 50%)`;
                                        boxShadowColor =
                                          'rgba(128, 0, 128, 0.26)';
                                      } else if (isPickup) {
                                        dotColor = '#ef5350';
                                        boxShadowColor = alpha('#ef5350', 0.26);
                                      } else if (isDelivery) {
                                        dotColor = '#0288d1';
                                        boxShadowColor = alpha('#0288d1', 0.26);
                                      }

                                      return (
                                        <TimelineDot
                                          className={classes.TimelineDot}
                                          sx={{
                                            bgcolor: dotBg
                                              ? 'transparent'
                                              : dotColor,
                                            background: dotBg,
                                            boxShadow: `0 0 0 8px ${boxShadowColor}`,
                                          }}
                                        >
                                          <StopCircleOutlined
                                            fontSize="small"
                                            sx={{ color: '#fff' }}
                                          />
                                        </TimelineDot>
                                      );
                                    })()}

                                    {idx < effectiveStops.length - 1 && (
                                      <TimelineConnector
                                        sx={{
                                          bgcolor: isEtaInvalid
                                            ? 'grey.300'
                                            : 'grey.400',
                                          width: 2,
                                        }}
                                      />
                                    )}
                                  </TimelineSeparator>

                                  <TimelineContent sx={{ py: 1, pl: 2 }}>
                                    {shipments.length === 0 ? (
                                      stop.type === 'garage' ? (
                                        <Typography variant="body2">
                                          <b>End-Adresse</b>
                                        </Typography>
                                      ) : (
                                        <Typography
                                          variant="body2"
                                          sx={
                                            stop.type === 'depot'
                                              ? {
                                                  fontSize: '13px',
                                                  lineHeight: '39px',
                                                  fontWeight: 400,
                                                }
                                              : undefined
                                          }
                                        >
                                          {stop.type === 'depot'
                                            ? 'DEPOT'
                                            : stop.type?.toUpperCase?.() ||
                                              'STOP'}
                                        </Typography>
                                      )
                                    ) : (
                                      shipments.map((shipment, shipmentIdx) => {
                                        const address =
                                          shipment.location?.address || {};
                                        const territory =
                                          shipment?.calculated_properties
                                            .territory;
                                        const load_class =
                                          shipment?.calculated_properties
                                            .load_classes;
                                        const addressParts = [];
                                        if (address.house_number)
                                          addressParts.push(
                                            address.house_number
                                          );
                                        if (address.street)
                                          addressParts.push(address.street);

                                        if (
                                          address.postal_code &&
                                          address.city
                                        ) {
                                          addressParts.push(
                                            `${address.postal_code} ${address.city}`
                                          );
                                        } else if (address.postal_code) {
                                          addressParts.push(
                                            address.postal_code
                                          );
                                        } else if (address.city) {
                                          addressParts.push(address.city);
                                        }

                                        if (address.country)
                                          addressParts.push(address.country);

                                        const addressString =
                                          addressParts.join(', ');

                                        const timeWindow =
                                          shipment.time_windows?.[0];
                                        const windowStart = timeWindow?.start
                                          ? localTime(
                                              new Date(timeWindow.start)
                                            )
                                          : null;
                                        const windowEnd = timeWindow?.end
                                          ? localTime(new Date(timeWindow.end))
                                          : null;
                                        return (
                                          <Box
                                            key={
                                              shipment.custom_id || shipmentIdx
                                            }
                                            sx={{ mb: 1, cursor: 'pointer' }}
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              const stopId = getStopId(
                                                stop,
                                                idx,
                                                tour.id
                                              );
                                              setSelectedStop({
                                                ...stop,
                                                id: stopId,
                                              });
                                              setSelectedStopId(stopId);
                                              setVisibleTours((prev) => ({
                                                ...prev,
                                                [tour.id]: true,
                                              }));
                                            }}
                                            onDoubleClick={() => {
                                              setSelectedStop(stop);
                                              setSelectedShipments(shipments);
                                              setModalOpen(true);
                                            }}
                                          >
                                            <ListItemText
                                              primary={
                                                <>
                                                  <Typography
                                                    variant="subtitle2"
                                                    component="div"
                                                  >
                                                    <Box
                                                      component="span"
                                                      style={{
                                                        fontWeight: '400',
                                                        fontSize: '13px',
                                                      }}
                                                    >
                                                      {shipment.customer_name ||
                                                        '--'}
                                                    </Box>
                                                  </Typography>
                                                  <Typography
                                                    variant="subtitle2"
                                                    component="div"
                                                  >
                                                    <Box
                                                      component="span"
                                                      style={{
                                                        fontWeight: '400',
                                                        fontSize: '13px',
                                                      }}
                                                    >
                                                      {addressString}
                                                    </Box>
                                                  </Typography>
                                                  <Typography
                                                    variant="subtitle2"
                                                    component="div"
                                                  >
                                                    <Box
                                                      display="flex"
                                                      alignItems="center"
                                                      gap={2}
                                                      style={{
                                                        fontWeight: 400,
                                                        fontSize: '13px',
                                                      }}
                                                    >
                                                      {shipment.priority && (
                                                        <Box
                                                          display="flex"
                                                          alignItems="center"
                                                        >
                                                          <LowPriorityOutlined
                                                            style={{
                                                              marginRight: 4,
                                                            }}
                                                          />
                                                          {shipment.priority}
                                                        </Box>
                                                      )}
                                                      {load_class && (
                                                        <Box
                                                          display="flex"
                                                          alignItems="center"
                                                        >
                                                          <LocalShippingOutlined
                                                            style={{
                                                              marginRight: 4,
                                                              fontSize: '20px',
                                                            }}
                                                          />
                                                          {load_class}
                                                        </Box>
                                                      )}
                                                    </Box>
                                                  </Typography>
                                                  <Box display="flex" gap={1}>
                                                    {[0, 1, 2].map(
                                                      (backendIdx) => {
                                                        const dimInfo =
                                                          getFrontendLabelByBackendIndex(
                                                            backendIdx
                                                          );
                                                        const value =
                                                          shipment.loads?.[
                                                            backendIdx
                                                          ] ?? '--';
                                                        return (
                                                          <Box key={backendIdx}>
                                                            <Box
                                                              component="span"
                                                              style={{
                                                                fontWeight:
                                                                  '400',
                                                                fontSize:
                                                                  '13px',
                                                                color:
                                                                  '#808080',
                                                              }}
                                                            >
                                                              {dimInfo.dimension ??
                                                                `Load ${
                                                                  backendIdx + 1
                                                                }`}
                                                              :
                                                            </Box>{' '}
                                                            <Tooltip
                                                              title={
                                                                dimInfo.unit ||
                                                                ''
                                                              }
                                                              placement="top"
                                                              arrow
                                                              componentsProps={{
                                                                tooltip: {
                                                                  sx: {
                                                                    fontSize:
                                                                      '12px',
                                                                    padding:
                                                                      '8px 12px',
                                                                  },
                                                                },
                                                              }}
                                                            >
                                                              <Box
                                                                component="span"
                                                                style={{
                                                                  fontWeight:
                                                                    '400',
                                                                  fontSize:
                                                                    '14px',
                                                                  cursor:
                                                                    'pointer',
                                                                }}
                                                              >
                                                                {value}
                                                              </Box>
                                                            </Tooltip>
                                                          </Box>
                                                        );
                                                      }
                                                    )}
                                                    {shipment.adr_points > 0 && (
                                                      <Box>
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '400',
                                                            fontSize: '13px',
                                                            color: '#808080',
                                                          }}
                                                        >
                                                          {i18next.t('common:weightWatcher.adrPoints')}:
                                                        </Box>{' '}
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '400',
                                                            fontSize: '14px',
                                                          }}
                                                        >
                                                          {shipment.adr_points}
                                                        </Box>
                                                      </Box>
                                                    )}
                                                  </Box>

                                                  <Collapse
                                                    in={openDetails[detailKey]}
                                                  >
                                                    {territory && (
                                                      <Typography
                                                        variant="subtitle2"
                                                        component="div"
                                                      >
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '700',
                                                          }}
                                                        >
                                                          {i18next.t(
                                                            'common:VehicleRouteList.territory'
                                                          )}
                                                          :
                                                        </Box>{' '}
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '400',
                                                          }}
                                                        >
                                                          {territory}
                                                        </Box>
                                                      </Typography>
                                                    )}
                                                    {windowStart && (
                                                      <Typography
                                                        variant="subtitle2"
                                                        component="div"
                                                      >
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '700',
                                                          }}
                                                        >
                                                          {i18next.t(
                                                            'common:VehicleRouteList.startTime'
                                                          )}
                                                          :
                                                        </Box>{' '}
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '400',
                                                          }}
                                                        >
                                                          {windowStart}
                                                        </Box>
                                                      </Typography>
                                                    )}

                                                    {windowEnd && (
                                                      <Typography
                                                        variant="subtitle2"
                                                        component="div"
                                                      >
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '700',
                                                          }}
                                                        >
                                                          {i18next.t(
                                                            'common:VehicleRouteList.endTime'
                                                          )}
                                                          :
                                                        </Box>{' '}
                                                        <Box
                                                          component="span"
                                                          style={{
                                                            fontWeight: '400',
                                                          }}
                                                        >
                                                          {windowEnd}
                                                        </Box>
                                                      </Typography>
                                                    )}
                                                  </Collapse>
                                                </>
                                              }
                                            />
                                            {shipmentIdx <
                                              shipments.length - 1 && (
                                              <Divider sx={{ my: 1 }} />
                                            )}
                                          </Box>
                                        );
                                      })
                                    )}
                                  </TimelineContent>
                                </TimelineItem>

                                {pendingCandidate && (
                                  <>
                                    <InsertHandle
                                      onClick={() => insertAt(tour.id, idx + 1)}
                                      label={i18next.t(
                                        'common:PendingShipments.between',
                                        { a: idx + 1, b: idx + 2 }
                                      )}
                                    />
                                    <DropSlot
                                      id={`slot::${tour.id}::${idx + 1}`}
                                      label={i18next.t(
                                        'common:PendingShipments.dropBetween',
                                        { a: idx + 1, b: idx + 2 }
                                      )}
                                    />
                                  </>
                                )}
                              </React.Fragment>
                            );
                          })}
                        </Timeline>

                        {stopContextMenu &&
                          stopContextMenu.tourId === tour.id && (
                            <Menu
                              open
                              onClose={() => setStopContextMenu(null)}
                              anchorReference="anchorPosition"
                              anchorPosition={
                                stopContextMenu
                                  ? {
                                      top: stopContextMenu.mouseY,
                                      left: stopContextMenu.mouseX,
                                    }
                                  : undefined
                              }
                            >
                              <MenuItem
                                onClick={() => {
                                  moveStopInTour(
                                    stopContextMenu.tourId,
                                    stopContextMenu.stopEffectiveIndex,
                                    stopContextMenu.stopEffectiveIndex - 1
                                  );
                                  setStopContextMenu(null);
                                }}
                              >
                                Move up
                              </MenuItem>

                              <MenuItem
                                onClick={() => {
                                  moveStopInTour(
                                    stopContextMenu.tourId,
                                    stopContextMenu.stopEffectiveIndex,
                                    stopContextMenu.stopEffectiveIndex + 1
                                  );
                                  setStopContextMenu(null);
                                }}
                              >
                                Move down
                              </MenuItem>

                              <MenuItem
                                onClick={() => {
                                  moveStopInTour(
                                    stopContextMenu.tourId,
                                    stopContextMenu.stopEffectiveIndex,
                                    0
                                  );
                                  setStopContextMenu(null);
                                }}
                              >
                                Move to top
                              </MenuItem>

                              <MenuItem
                                onClick={() => {
                                  moveStopInTour(
                                    stopContextMenu.tourId,
                                    stopContextMenu.stopEffectiveIndex,
                                    effectiveStops.length - 1
                                  );
                                  setStopContextMenu(null);
                                }}
                              >
                                Move to bottom
                              </MenuItem>

                              <Divider />

                              <MenuItem
                                onClick={() => {
                                  setMoveDialog({
                                    tourId: stopContextMenu.tourId,
                                    fromIndex:
                                      stopContextMenu.stopEffectiveIndex,
                                  });
                                  setTargetPosition('');
                                  setStopContextMenu(null);
                                }}
                              >
                                Move to position…
                              </MenuItem>
                            </Menu>
                          )}

                        {pendingCandidate && (
                          <>
                            <InsertHandle
                              onClick={() =>
                                insertAt(tour.id, effectiveStops.length)
                              }
                              label={i18next.t('common:PendingShipments.atEnd')}
                            />
                            <DropSlot
                              id={`slot::${tour.id}::${effectiveStops.length}`}
                              label={i18next.t(
                                'common:PendingShipments.dropAtEnd'
                              )}
                            />
                          </>
                        )}
                      </Box>
                    )}
                  </Box>
                );
              })}
            </Box>
          </Card>
        </DndContext>
      </Box>

      {modalOpen && (
        <DetailShipmentForm
          open
          onClose={() => {
            setModalOpen(false);
            setSelectedShipments([]);
            setSelectedStop(null);
          }}
          stop={selectedStop}
          shipments={selectedShipments ?? []}
        />
      )}
      {moveDialog && (
        <Dialog
          open
          onClose={() => {
            setMoveDialog(null);
            setTargetPosition('');
          }}
          fullWidth
          maxWidth="xs"
        >
          {/* Title with icon */}
          <DialogTitle sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <FormatListNumbered color="primary" />
            Move stop to position
          </DialogTitle>

          <DialogContent sx={{ pt: 1 }}>
            {/* Short helper text */}
            <Typography variant="body2" sx={{ mb: 1, color: 'text.secondary' }}>
              Enter the new position for this stop in the tour.
            </Typography>

            <TextField
              autoFocus
              margin="dense"
              label="Position number"
              placeholder="e.g. 5"
              type="number"
              fullWidth
              size="small"
              value={targetPosition}
              onChange={(e) => setTargetPosition(Number(e.target.value))}
              inputProps={{
                min: 1,
                max: (() => {
                  const t = tours.find((tt) => tt.id === moveDialog.tourId);
                  const stops = t?.stops || [];
                  const hasDepot = stops[0]?.type === 'depot';
                  // effective stops ki max position
                  return hasDepot
                    ? Math.max(stops.length - 1, 1)
                    : Math.max(stops.length, 1);
                })(),
              }}
            />

            {/* Info strip */}
            <Box
              sx={{
                mt: 1.5,
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                bgcolor: (theme) => theme.palette.action.hover,
                borderRadius: 1,
                p: 1,
              }}
            >
              <InfoOutlined sx={{ fontSize: 18, color: 'text.secondary' }} />
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                Valid positions: 1 –
                {(() => {
                  const t = tours.find((tt) => tt.id === moveDialog.tourId);
                  const stops = t?.stops || [];
                  const hasDepot = stops[0]?.type === 'depot';
                  return hasDepot
                    ? Math.max(stops.length - 1, 1)
                    : Math.max(stops.length, 1);
                })()}
              </Typography>
            </Box>
          </DialogContent>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => {
                setMoveDialog(null);
                setTargetPosition('');
              }}
              sx={{ fontWeight: 500 }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                const pos = Number(targetPosition) - 1;
                if (!Number.isNaN(pos)) {
                  moveStopInTour(moveDialog.tourId, moveDialog.fromIndex, pos);
                }
                setMoveDialog(null);
              }}
              variant="contained"
              disabled={targetPosition === '' || Number(targetPosition) <= 0}
            >
              Move
            </Button>
          </DialogActions>
        </Dialog>
      )}

      {weightWatcherOpen && (
        <WeightWatcher
          open={weightWatcherOpen}
          close={() => setWeightWatcherOpen(false)}
          route={uiTours}
          routeId={0}
          vehicle={weightWatcherVehicle}
          dimensions={settings.load_dimensions || []}
          position={{ x: 0, y: 0 }}
        />
      )}
    </Box>
  );
};

export default VehicleRoutes;
